import React from 'react';
import TeamDashboard from '../src/components/TeamDashboard';

const TeamDashboardPage: React.FC = () => {
  return <TeamDashboard />;
};

export default TeamDashboardPage;
